import PageHeader from "@/components/settings/PageHeader";
import { assetPath } from '@/utils/assetPath';
import { createFileRoute } from "@tanstack/react-router";

const subscriptionData = [
  {
    name: "nolan_gouse",
    subscription: "Monthly subscription · 1.3 year",
    price: "$105",
  },
  {
    name: "davis_george",
    subscription: "Annually subscription / 3 month",
    price: "$12",
  },
  {
    name: "terry_press",
    subscription: "Free subscription / 2 year",
    price: "Free",
  },
];

export const Route = createFileRoute("/settings/dashboard")({
  component: RouteComponent,
});

function RouteComponent() {
  return <DashboardPage />;
}

const DashboardPage = () => {
  return (
    <div className="h-[100dvh] overflow-y-auto bg-white px-2 pb-14">
      <PageHeader title="Dashboard" />

      {/* Stats Card */}
      <div className="mt-6 py-6 bg-white rounded-2xl border border-black-6">
        <div className="flex flex-col items-center">
          <div className="relative w-full h-40">
            {/* Chart container */}
            <div className="absolute w-full flex justify-center">
              <div className="relative w-80 h-40 overflow-hidden">
                <div className="absolute w-80 h-80 rounded-full border-[30px] border-[#001E4D] top-0"></div>

                <div
                  className="absolute w-80 h-80 rounded-full border-[30px] border-blue top-0"
                  style={{ clipPath: "polygon(50% 50%, 0 0, 0 50%, 14% 50%)" }}
                ></div>
                <div
                  className="absolute w-80 h-80 rounded-full border-[30px] border-white top-0"
                  style={{ clipPath: "polygon(50% 50%, 0 0, 0 10%, 0% 5%)" }}
                ></div>
              </div>
            </div>

            {/* Percentage labels */}
            <div className="absolute top-0 left-4 text-left">
              <p className="text-blue font-bold text-16">13.6%</p>
              <p className="text-black-48 text-13">Paid</p>
            </div>
            <div className="absolute top-0 right-4 text-right">
              <p className="text-navy-900 font-bold text-16">86.4%</p>
              <p className="text-black-48 text-13">Free</p>
            </div>

            {/* Center stats */}
            <div className="absolute top-14 left-0 right-0 flex flex-col items-center">
              <div className="flex items-center justify-center mb-1">
                <img src={assetPath('icons/settings/users.svg')} alt="Users" />
              </div>
              <p className="text-32 font-normal">312</p>
              <p className="text-black-48 text-sm">Total users</p>
            </div>
          </div>
        </div>
      </div>

      {/* Revenue Chart */}
      <div className="mt-6 p-2 bg-white rounded-2xl border border-black-6">
        <div className="h-52 flex items-end space-x-2">
          {/* Y-axis labels */}
          <div className="text-right pr-2 text-black-48 text-13 h-full flex flex-col justify-between">
            <div>$15 000</div>
            <div>$10 000</div>
            <div>$5 000</div>
            <div>$1 000</div>
            <div>$0</div>
          </div>

          {/* Chart bars */}
          <div className="flex-1 flex space-x-4 items-end">
            <div className="flex-1 flex flex-col items-center">
              <div className="w-full bg-gray-200 rounded-full h-28"></div>
              <span className="mt-2 text-xs text-black-48">Sep</span>
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="w-full bg-gray-200 rounded-full h-36"></div>
              <span className="mt-2 text-xs text-black-48">Oct</span>
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="w-full bg-blue rounded-full h-44"></div>
              <span className="mt-2 text-xs text-blue font-medium">Nov</span>
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="w-full bg-gray-200 rounded-full h-40"></div>
              <span className="mt-2 text-xs text-black-48">Dec</span>
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="w-full bg-gray-200 rounded-full h-40"></div>
              <span className="mt-2 text-xs text-black-48">Jan</span>
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="w-full bg-gray-200 rounded-full h-28"></div>
              <span className="mt-2 text-xs text-black-48">Feb</span>
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="w-full bg-gray-200 rounded-full h-44"></div>
              <span className="mt-2 text-xs text-black-48">Mar</span>
            </div>
          </div>
        </div>
      </div>

      {/* Subscriptions */}
      <div className="mt-8 mb-8">
        <h2 className="text-16 font-normal mb-3">Subscriptions</h2>

        {/* Subscription cards */}
        <div className="flex flex-col gap-3">
          {subscriptionData?.map((item) => (
            <div
              key={item.name}
              className="flex items-center justify-between bg-white "
            >
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-full bg-red-500 mr-3"></div>
                <div>
                  <p className="font-normal text-14">{item.name}</p>
                  <p className="text-black-48 font-normal text-13">
                    {item.subscription}
                  </p>
                </div>
              </div>
              <div className="font-normal text-14">{item.price}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
